import { Button as ButtonV2 } from '@dealstack/frontend/shared/components/fundament/Button/Button.v2';
import { FormCheckbox } from '@dealstack/frontend/shared/components/forms/FormCheckbox/FormCheckbox';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import {
	BottomWrapper,
	ButtonGroup,
	HeaderText,
	MessageWrapper,
	NotificationCheckboxWrapper,
	StyledTextarea,
	TopWrapper,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/RequestKycModal/styles';

interface Props {
	onClose: () => void;
	onConfirm: () => void;
	investorCount: number;
	form: UseFormReturn<{ customizedEmailBody: string; sendNotification: boolean }>;
}

export const ContentView = ({ onClose, onConfirm, investorCount, form }: Props) => {
	const tMipManage = useTranslationMipManage();
	const sendNotification = form.watch('sendNotification');

	return (
		<FormProvider {...form}>
			<div style={{ padding: '1rem' }}>
				<TopWrapper>
					<HeaderText variant="sans/17/800" disableVariantMapping>
						{tMipManage('kyc_request_modal.header', {
							totalInvestorNumber: investorCount.toString(),
						})}
					</HeaderText>
				</TopWrapper>
				<MessageWrapper>
					<StyledTextarea
						name="customizedEmailBody"
						rows={10}
						fullWidth
						disabled={!sendNotification}
						placeholder={tMipManage('kyc_request_modal.email_default')}
					/>
				</MessageWrapper>
				<BottomWrapper>
					<NotificationCheckboxWrapper>
						<FormCheckbox
							name="sendNotification"
							label={tMipManage('kyc_request_modal.send_notification_label')}
						/>
					</NotificationCheckboxWrapper>
					<ButtonGroup>
						<ButtonV2
							size="s"
							icon="close-v3"
							rightIcon
							buttonTheme="light"
							variant="ghost"
							onClick={onClose}
						>
							{tMipManage('kyc_request_modal.cancel')}
						</ButtonV2>
						<ButtonV2
							size="s"
							icon={sendNotification ? 'mail' : undefined}
							buttonTheme="light"
							variant="primary"
							leftIcon={sendNotification}
							onClick={onConfirm}
						>
							{sendNotification
								? tMipManage('kyc_request_modal.send_button', {
										totalInvestorNumber: investorCount.toString(),
									})
								: tMipManage('kyc_request_modal.start_button', {
										totalInvestorNumber: investorCount.toString(),
									})}
						</ButtonV2>
					</ButtonGroup>
				</BottomWrapper>
			</div>
		</FormProvider>
	);
};
